import { getApiActionCreator } from 'helpers/actionHelper';
import { actionTypes } from './constants';
import { loadPowertrainsV2 } from '../../GeneralFilter/GeneralFilterModal/actions';


export const getPowertrainsAction = getApiActionCreator(actionTypes.GET_POWERTRAINS);
export const deletePowertrainAction = getApiActionCreator(actionTypes.DELETE_POWERTRAIN);
export const convertToLocationAction = getApiActionCreator(actionTypes.CONVERT_TO_LOCATION);
export const getHierarchyDataAction = getApiActionCreator(actionTypes.GET_HIERARCHY_DATA_SETTINGS);
export const updateHierarchyDataAction = getApiActionCreator(actionTypes.UPDATE_HIERARCHY_DATA_SETTINGS);

//TO DO: edit when common powertrain list is used for configuration and overview
export const getOverviewPowertrainsAction = getApiActionCreator(actionTypes.GET_OVERVIEW_POWERTRAINS);

export const setSelectedPowertrain = (powertrain) => {
    return {
        type: actionTypes.SET_SELECTED_POWERTRAIN,
        powertrain
    };
};

export const clearStore = () => {
    return (dispatch) => {
        dispatch({ type: actionTypes.CLEAR_STORE });
    };
};

export const setSearchboxFilter = (searchboxFilter) => {
    return {
        type: actionTypes.SET_SEARCHBOX_FILTER,
        searchboxFilter
    };
};

export const setPowertrainForEditing = (powertrain) => {
    return {
        type: actionTypes.SET_POWERTRAIN_FOR_EDITING,
        powertrain
    };
};

export const getPowertrainsRequest = (siteIds, organizationIds, nameFilter, pageNumber) => ({
    type: actionTypes.LOAD_POWERTRAINS_REQUEST,
    siteIds,
    organizationIds,
    nameFilter,
    pageNumber
});

export const deletePowertrainRequest = (powertrainId, organizationIds, siteIds, nameFilter) => ({
    type: actionTypes.DELETE_POWERTRAIN_REQUEST,
    powertrainId,
    organizationIds,
    siteIds,
    nameFilter
});

export const convertToLocationRequest = (powertrainId, siteId, organizationId) => ({
    type: actionTypes.CONVERT_TO_LOCATION_REQUEST,
    powertrainId,
    siteId,
    organizationId
});

//TO DO: edit when common powertrain list is used for configuration and overview
export const reloadOverviewPowertrainsRequest = () => {
    return (dispatch, getState) => {
        const sites = getState().generalFilter.sites.data;
        const selectedFilters = getState().generalFilterEdit.selectedFilters;
        loadPowertrainsV2(sites, selectedFilters?.organizations, true, dispatch, selectedFilters?.countries);
    };
};

export const initializeDataRequest = (organizationId, siteIds, organizationIds) => {
    return {
        type: actionTypes.INITIALIZE_DATA_REQUEST,
        organizationId,
        siteIds,
        organizationIds
    };
};

export const getHierarchyDataRequest = (organizationId, siteIds = null) => {
    return {
        type: actionTypes.GET_HIERARCHY_DATA_REQUEST,
        organizationId,
        siteIds
    };
};

export const updateHierarchyDataRequest = (hierarchyRequestData, callback, setHierarchyErrorModal, setSaveFailed, moveContext, nodeMap) => {
    return {
        type: actionTypes.UPDATE_HIERARCHY_DATA_REQUEST,
        hierarchyRequestData,
        callback,
        setHierarchyErrorModal,
        setSaveFailed,
        moveContext,
        nodeMap
    };
};

export const setSelectedHierarchyNodes = (selectedNodes) => {
    return {
        type: actionTypes.SET_SELECTED_HIERARCHY_NODES,
        selectedNodes
    };
};

export const setHierarchyExpandedNodes = (expandedIds) => {
    return {
        type: actionTypes.SET_HIERARCHY_EXPANDED_NODES,
        expandedIds
    };
};

export const setIsEditHierarchy = (isEditHierarchy) => {
    return {
        type: actionTypes.SET_IS_EDIT_HIERARCHY,
        isEditHierarchy
    };
};

export const setHierarchyRequestData = (requestData) => {
    return {
        type: actionTypes.SET_HIERARCHY_REQUEST_DATA,
        requestData
    };
};

export const setHierarchySelectedAssets = (selectedAssets) => {
    return {
        type: actionTypes.SET_HIERARCHY_SELECTED_ASSETS,
        selectedAssets
    };
};

export const setHierarchyErrorModal = (isVisible) => {
    return {
        type: actionTypes.SET_HIERARCHY_ERROR_MODAL,
        isVisible
    };
};

export const setSaveFailed = (isSaveFailed) => {
    return {
        type: actionTypes.SET_SAVE_FAILED,
        isSaveFailed
    };
};

export const setPartialPowertrainFailure = (isPartialPowertrainFailure) => {
    return {
        type: actionTypes.SET_PARTIAL_POWERTRAIN_FAILURE,
        isPartialPowertrainFailure
    };
};

export const setConversionResult = (conversionResult) => {
    return {
        type: actionTypes.SET_CONVERSION_RESULT,
        conversionResult
    };
};

export const clearConversionResult = () => {
    return {
        type: actionTypes.CLEAR_CONVERSION_RESULT
    };
};
